
<table class="width-100per">
  <thead>
    <tr class="border-bottom-0px">
      <td>
        <div class="printheader-space"
             [style.height.px]="BillPrintHeaderHeight">&nbsp;</div>
      </td>
    </tr>
  </thead>
  <tbody>
    <tr class="border-bottom-0px">
      <td>
        <div class="content">
          <router-outlet></router-outlet>
          <router-outlet name="print"></router-outlet>
          <!--<router-outlet name="eggsource"></router-outlet>
          <router-outlet name="folliculargrowth"></router-outlet>
          <router-outlet name="pickupdetails"></router-outlet>
          <router-outlet name="oocytequality"></router-outlet>
          <router-outlet name="spermsourcedetails"></router-outlet>
          <router-outlet name="semendataanalysis"></router-outlet>
          <router-outlet name="inseminationlog"></router-outlet>
          <router-outlet name="embryotransfer"></router-outlet>-->
        </div>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr class="border-bottom-0px">
      <td>
        <div class="printfooter-space"
             [style.height.px]="BillPrintFooterHeight">&nbsp;</div>
      </td>
    </tr>
  </tfoot>
</table>




<div>
  <div class="printheader" *ngIf="ShowBillPrintHeaderLogoCustomer == 'true'"
       [style.height.px]="BillPrintHeaderHeight">
    <div class="card borderbot5px background-color-wt">
      <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px">
        <div class="col-md-12 padding-left-0px">
          <div class="row margin-left-0px">
            <div class="col-md-1 padding-left-0px padding-right-0px">
              <img [src]="logo"
                   [style.width.px]="PrintlogoWidth"
                   [style.height.px]="PrintlogoHeight"
                   [style.border-radius.%]="PrintlogoBorderRadius"
                   class="">
            </div>

            <div class="col-md-6">
              <div class="row margin-left-0px">
                <label class="margin-bottom-0px font-weight-normal font-familysubhead">{{HeaderLine1}}</label>
              </div>
              <div class="row margin-left-0px">
                <label class="margin-bottom-0px font-weight-normal font-family">{{HeaderLine2}}</label>
              </div>
              <div class="row margin-left-0px" *ngIf="GST">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal">{{ClientHeaderSubTitle1}}</label>
                </div>
                <div class="col-print-10">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{GST}}</label>
                </div>
              </div>
              <div class="row margin-left-0px" *ngIf="DL">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal">{{ClientHeaderSubTitle2}}</label>
                </div>
                <div class="col-print-10">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DL}}</label>
                </div>
              </div>
            </div>

            <div class="col-md-5 padding-right-5px border-color-blue" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">Customer Details</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-familysubhead float-right font-weight-bold font-color-blue">{{l.DisplayName}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal font-color-blue">ID : {{l.FormattedCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">Sex/Age : {{l.Gender}}/{{l.Age}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal"><i class="fas fa-phone"></i> : {{l.Telephone1}}</label>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
      <div class="card-body padding-top-0px padding-bottom-0px">

      </div>

    </div>
  </div>
  <div class="printheader" *ngIf="ShowBillPrintHeaderLogo == 'true'"
       [style.height.px]="BillPrintHeaderHeight">
    <div class="card borderbot5px background-color-wt">
      <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px">
        <div class="col-md-12 padding-left-0px">
          <div class="row margin-left-0px">
            <div class="col-md-1 padding-left-0px padding-right-0px">
              <img [src]="logo"
                   [style.width.px]="PrintlogoWidth"
                   [style.height.px]="PrintlogoHeight"
                   [style.border-radius.%]="PrintlogoBorderRadius"
                   class="">
            </div>

            <div class="col-md-6">
              <div class="row margin-left-0px">
                <label class="margin-bottom-0px font-weight-normal font-familysubhead">{{HeaderLine1}}</label>
              </div>
              <div class="row margin-left-0px">
                <label class="margin-bottom-0px font-weight-normal font-family">{{HeaderLine2}}</label>
              </div>
              <div class="row margin-left-0px" *ngIf="GST">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal">{{ClientHeaderSubTitle1}}</label>
                </div>
                <div class="col-print-10">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{GST}}</label>
                </div>
              </div>
              <div class="row margin-left-0px" *ngIf="DL">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal">{{ClientHeaderSubTitle2}}</label>
                </div>
                <div class="col-print-10">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DL}}</label>
                </div>
              </div>
            </div>


          </div>

        </div>
      </div>
      <div class="card-body padding-top-0px padding-bottom-0px">

      </div>

    </div>
  </div>
  <div class="printheader" *ngIf="BillPrintHeaderEmpty == 'true'"
       [style.height.px]="BillPrintHeaderHeight">

  </div>

  <div class="printfooter" *ngIf="ShowBillPrintFooter == 'true'"
       [style.height.px]="BillPrintFooterHeight">

    <div class="card footerborder-top">

      <div class="card-header border-bottom-0px padding-bottom-0px padding-top-5px padding-left-0px padding-right-0px">

      </div>
      <div class="card-body padding-top-0px padding-bottom-0px background-color-wt padding-left-0px">
        <div class="row margin-left-0px margin-right-5px">

          <div class="col-md-8 footerborder-right padding-left-5px padding-right-5px">

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-weight-normal font-family">{{ClientHeaderFooterLine1}}</label>
            </div>
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-weight-normal font-family">{{ClientHeaderFooterLine2}}</label>
            </div>
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-weight-normal font-family">{{ClientHeaderFooterLine3}}</label>
            </div>
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-weight-normal font-family">{{ClientHeaderFooterLine4}}</label>
            </div>

          </div>

          <div class="col-md-3 padding-left-0px padding-right-0px"></div>

          <div class="col-md-1 padding-left-0px padding-right-0px">

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-weight-normal font-family">
                <qrcode class="padding-top-0px padding-bottom-0px" [qrdata]="BillNumber" [size]="90" [level]="'M'"></qrcode>
              </label>
            </div>

          </div>

        </div>
        <!--<div class="row">
          <div class="col-md-9">

          </div>
          <div class="col-md-3">
            <label class="margin-bottom-0px font-family13px">Print Taken: {{Date | date:'dd-MMM-yyyy'}}</label>
          </div>
        </div>-->
        <!--<div class="row">
          <div class="col-print-9">

          </div>
          <div class="col-print-3">
            <label class="margin-bottom-0px font-family13px footer_info_Mh"></label>
          </div>
        </div>-->
      </div>

    </div>

  </div>
  <div class="printfooter" *ngIf="ShowBillPrintFooterEmpty == 'true'"
       [style.height.px]="BillPrintFooterHeight">

  </div>

</div>
